var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService1Icon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 29C17.7954 29 18.5585 28.6839 19.1211 28.1213C19.6837 27.5587 19.9998 26.7956 19.9998 26C19.9998 25.2044 19.6837 24.4413 19.1211 23.8787C18.5585 23.3161 17.7954 23 16.9998 23C17.7954 23 18.5585 22.6839 19.1211 22.1213C19.6837 21.5587 19.9998 20.7956 19.9998 20C19.9998 19.2044 19.6837 18.4413 19.1211 17.8787C18.5585 17.3161 17.7954 17 16.9998 17H12.9998V29H16.9998Z",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 23H17.2491",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 17V15",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 31V29",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99976 31H4.99976C4.46932 31 3.96062 30.7893 3.58554 30.4142C3.21047 30.0391 2.99976 29.5304 2.99976 29V13C2.99976 12.4696 3.21047 11.9609 3.58554 11.5858C3.96062 11.2107 4.46932 11 4.99976 11H26.9998C27.5302 11 28.0389 11.2107 28.414 11.5858C28.789 11.9609 28.9998 12.4696 28.9998 13V29C28.9998 29.5304 28.789 30.0391 28.414 30.4142C28.0389 30.7893 27.5302 31 26.9998 31H21.9998",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 11H8.99976V8C8.99976 6.14348 9.73725 4.36301 11.05 3.05025C12.3628 1.7375 14.1432 1 15.9998 1C17.8563 1 19.6367 1.7375 20.9495 3.05025C22.2623 4.36301 22.9998 6.14348 22.9998 8V11Z",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1Icon2);
export default __webpack_public_path__ + "static/media/service1-icon2.556e09d4e414ed0384833759f856e0cd.svg";
export { ForwardRef as ReactComponent };